export default "__VITE_ASSET__B53xTRmo__"